<template>
    <div class="login">
        <div class="userImg">
            <img :src="logo">
        </div>
        <p class="text_c font_6 fs18 mt28">{{ desc }}</p>
        <section class="enterBox">
            <div class="inputBox">
                <img src="../assets/img/icon/userName.svg" alt="用户名">
                <input v-model="username" type="text" placeholder="请输入用户名">
            </div>
            <div class="inputBox">
                <img src="../assets/img/icon/password.svg" alt="密码">
                <input v-model="password" type="password" placeholder="请输入密码">
            </div>
        </section>

        <div :class="{ noClick: !username || !password }" @click="toLogin" class="co_fff text_c fs18 font_b loginBtn">登录</div>
    </div>
</template>

<script>

import _co from "@/util/const";
export default {
    name: "Login",
    data() {
        return {
            username: '',
            password: '',
            logo:"",
            desc: ""
        }
    },
    mounted() {
        let {login} = _co.siteConfig;
        this.logo = login.imagePath;
        this.desc = login.desc;
    },
    methods: {
        async toLogin() {
            if(!this.username || !this.password)
                return ;

            localStorage.removeItem('xinhuaUser');
            localStorage.removeItem('company');

            let resp = await this.baseApi.login({
                account: this.username,
                password: this.password
            });
            if(!resp)
                return ;
            this.$router.push({path: "/"});

        }
    }
}
</script>

<style lang="scss" scoped>
.login {
    font-family: PingFangSC-Regular;
    width: 100vw;
    height: 100vh;
    //background-color: #FAFCFF;
    padding-top: 110px;

    .noClick {
        //pointer-events: none;
        opacity: 0.5;
    }

    .userImg {
        width: 98px;
        height: 98px;
        margin: 0 auto;
        border-radius: 50%;
        background-color: #ffffff;
        img{
            width: 98px;
            height: 98px;
        }
    }

    .enterBox {
        width: calc(100vw - 75px);
        margin: 60px auto 0;
        padding-bottom: 20px;

        .inputBox {
            border-bottom: 1px solid rgba(237, 237, 237, 1);
            position: relative;
            margin-bottom: 35px;

            img {
                width: 20px;
                height: 20px;
                position: absolute;
                top: 7px;
                left: 0;
            }

            input {
                color: #B0B0B0;
                width: 100%;
                height: 34px;
                line-height: 34px;
                font-size: 14px;
                border: none;
                outline: none;
                text-indent: 32px;
                background-color: transparent;
            }
        }
    }

    .loginBtn {
        width: calc(100vw - 50px);
        height: 48px;
        line-height: 48px;
        border-radius: 4px;
        margin: 0 auto;
        background-color: rgba(83, 141, 255, 1);
        box-shadow: 0px 2px 8px rgba(85, 122, 218, 0.5);
        cursor: pointer;
    }
}
</style>